<template>
  <a
    :target="target"
    :class="[
      'hover:cursor-pointer',
      variant === 'primary' && 'text-theme-3 underline hover:text-theme-3b active:text-theme-3c',
      variant === 'bold' &&
        'rounded-md px-2 py-1 text-sm font-medium text-theme-1 no-underline transition-colors duration-300 hover:bg-color-bg-secondary',
    ]"
    :href="url"
  >
    <slot> {{ text }} </slot>
  </a>
</template>

<script setup lang="ts">
interface Props {
  text?: string;
  url?: string;
  target?: string;
  variant?: "primary" | "bold";
}

withDefaults(defineProps<Props>(), {
  target: "_blank",
  variant: "primary",
});
</script>
